import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { trackEvent } from "../components/Analytics.js";

const QuoteContext = createContext(null);
const storageKey = "containx_quote_items";

const loadItems = () => {
  try { return JSON.parse(localStorage.getItem(storageKey)) || []; }
  catch { return []; }
};

export const QuoteProvider = ({ children }) => {
  const [items, setItems] = useState(loadItems);

  useEffect(() => { localStorage.setItem(storageKey, JSON.stringify(items)); }, [items]);

  const value = useMemo(() => ({
    items,
    itemCount: items.length,
    addItem(item) {
      setItems((current) => {
        const existing = current.find((entry) => entry.id === item.id);
        return existing
          ? current.map((entry) => entry.id === item.id ? { ...entry, cases: entry.cases + 1 } : entry)
          : [...current, { ...item, cases: 1 }];
      });
      trackEvent("quote_item_added", { item_id: item.sku, item_name: item.productName });
    },
    updateCases(id, cases) {
      const safeCases = Math.max(1, Math.min(999, Number(cases) || 1));
      setItems((current) => current.map((item) => item.id === id ? { ...item, cases: safeCases } : item));
    },
    removeItem(id) { setItems((current) => current.filter((item) => item.id !== id)); },
    clearQuote() { setItems([]); },
  }), [items]);

  return <QuoteContext.Provider value={value}>{children}</QuoteContext.Provider>;
};

export const useQuote = () => {
  const context = useContext(QuoteContext);
  if (!context) throw new Error("useQuote must be used within QuoteProvider");
  return context;
};
